import React, { useState } from 'react';
import PageHeader from 'components/common/PageHeader';
import { Accordion, Card } from 'react-bootstrap';
import { faqDoc } from 'data/faqs';
import FaqAccordionItem from 'components/pages/faq/faq-accordion/FaqAccordionItem';

const Faq = () => {
  const [faqs] = useState(faqDoc);
  return (
    <>
      <PageHeader
        title="FAQ Preguntas Frecuentes"
        description="En esta sección se describen las funcionalidades principales del Sistema de Gestión Académica, detallando los módulos y la usabilidad de cada sección.
 El manual está destinado a administradores, docentes y personal administrativo, con el objetivo de facilitar el uso correcto de la plataforma y optimizar los procesos de registro, seguimiento académico y gestión económica de la institución.
"
        className="mb-3"
      />
      <Card>
        <Card.Body>
          <Accordion
            id="accordionFaq"
            className="border rounded overflow-hidden"
          >
            {faqs.map((faq, index) => (
              <FaqAccordionItem
                key={faq.id}
                faq={faq}
                isFirst={index === 0}
                isLast={index === faqs.length - 1}
              />
            ))}
          </Accordion>
        </Card.Body>
      </Card>
    </>
  );
};

export default Faq;
